import { useState, useCallback } from "react";
import useApi from "../useApi";
import { IBillingMinutesRes } from "./index.type";
import toast from "react-hot-toast";

interface UseGetBillingMinutesProps {
  billingCycleId: string;
}

const useGetBillingMinutes = ({
  billingCycleId,
}: UseGetBillingMinutesProps) => {
  const [billingMinutesData, setBillingMinutesData] = useState<
    IBillingMinutesRes | undefined
  >();

  const { loading: billingMinutesLoading, makeApiCall } = useApi({
    url: `/rtm/timer/minutes?billingCycleId=${billingCycleId}`,
    method: "GET",
  });

  const getBillingMinutesData = useCallback(async () => {
    if (!billingCycleId) return;

    const { response, error } = await makeApiCall<void, IBillingMinutesRes>();
    if (response) {
      setBillingMinutesData(response);
      return response;
    }

    if (error) {
      toast.error(error.msg);
      setBillingMinutesData(undefined);
    }
  }, [billingCycleId, makeApiCall]);

  return {
    billingMinutesLoading,
    billingMinutesData,
    getBillingMinutesData,
  };
};

export default useGetBillingMinutes;
